import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmsubscribe/cecUnmSubscribe/import',
      method: 'post',
      data: data
    })
  }
}
